import Vue from 'vue';
import Vuex from 'vuex';

import {SET_TOKEN, SAVE_SEARCH, SET_PERMISOS} from './store-mutations';
import {STORAGE_PERMISSIONS, STORAGE_TOKENS} from '../constants';
import { LOGOUT } from "./store-actions";
import * as snackbars from './modules/snackbars';
import * as empresas from './modules/empresas';
import * as personas from './modules/personas';
import * as auth from './modules/auth';
import * as partidasArancelarias from './modules/partidas-arancelarias';
import * as formularios from './modules/formularios';
import * as estados from './modules/estados';


Vue.use(Vuex);

export const state = {
  search: JSON.parse(sessionStorage.getItem('search') || '{}'),
  permisos: JSON.parse(localStorage.getItem('permisosReservapy') || '[]'),
  token: localStorage.getItem(STORAGE_TOKENS),
};

export const getters = {
  getSearch: state => componentName => state.search[componentName] || {search: null, advance: null},
  permisos: state => {
    const permisos = state.permisos;
    return permisos ? permisos.map(p => p.descripcion) : [];
  },
  loggedIn: state => {
    const token = state.token;
    return token && token.length > 0;
  }
};

export const mutations = {
  [SET_TOKEN] (state, token) {
    state.token = token;
    if (token) {
      window.localStorage.setItem(STORAGE_TOKENS, token);
    } else {
      window.localStorage.removeItem(STORAGE_TOKENS);
    }
  },
  [SAVE_SEARCH] (state, payload) {
    state.search[payload.componentName] = payload.search;
    sessionStorage.setItem('search', JSON.stringify(state.search));
  },
  [SET_PERMISOS] (state, permisos) {
    localStorage.setItem(STORAGE_PERMISSIONS, JSON.stringify(permisos));
    state.permisos = permisos;
  },

};

export const actions = {
  [LOGOUT] ({commit, dispatch}) {
    commit(SET_TOKEN, null);
    dispatch('auth/setUsuario', null, {root: true});
    window.localStorage.removeItem(STORAGE_PERMISSIONS);
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    snackbars,
    empresas,
    auth,
    personas,
    partidasArancelarias,
    formularios,
    estados,
  },
});
